module.exports = __webpack_public_path__ + "static/media/back-blue.49c4f44a.svg";